import { orchestrator } from 'satcheljs';
import { resetFullCompose, closeComposeForm } from 'owa-calendar-compose-form-actions';
import { isInDeeplinkPopOutWindow } from 'owa-calendar-compose-form-store/lib/selectors/popoutSelectors';
import { isEventAMeeting } from 'owa-calendar-event-capabilities';
import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { FullComposeFormViewType } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { lazyOpenCalendarFullCompose } from 'owa-calendar-compose-form-lifecycle';

orchestrator(resetFullCompose, actionMessage => {
    const isDeeplinkPopout = isInDeeplinkPopOutWindow(actionMessage.formId);

    // Close the current compose form and then open one for the new event/scope
    // For deeplink popouts, keep the window open and re-use it
    closeComposeForm(
        actionMessage.formId,
        isEventAMeeting(getComposeEvent(actionMessage.formId)) /* isMeeting */,
        true /* shouldResetComposeStore */,
        !isDeeplinkPopout /* shouldClosePopOutWindow */,
        false /* shouldClearPreview */
    );

    lazyOpenCalendarFullCompose.importAndExecute({
        fullComposeEntrySource: actionMessage.entrySource,
        viewType: isDeeplinkPopout ? FullComposeFormViewType.DeeplinkPopOut : undefined,
        eventScope: actionMessage.eventScope,
        eventUpdates: actionMessage.event,
    });
});
